import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
import { Check } from 'lucide-react';
export function ServicesSection() {
  const {
    lang
  } = useLanguage();
  const caminos = [{
    id: 'construye',
    accent: '#C084FC',
    accentRgb: '192, 132, 252',
    btnClass: 'bg-inkova-lavender text-inkova-dark hover:bg-inkova-primary hover:text-white',
    tag: 'CAMINO 01',
    name: 'Construye',
    nameEn: 'Build',
    tagline: 'Tienes el talento. Nosotros construimos el negocio.',
    taglineEn: 'You have the talent. We build the business.',
    badge: 'Para quien empieza desde cero',
    badgeEn: 'For those starting from scratch',
    checklist: ['Sesión de claridad — qué vendes, a quién y cómo', 'Identidad visual y posicionamiento', 'Web profesional con sistema de cobro', 'Email corporativo + dominio', 'Redes sociales configuradas', 'Brand kit + plantillas en Canva', 'Dashboard para ver tu actividad web', 'LLC en Florida (add-on opcional)'],
    checklistEn: ['Clarity session — what you sell, to whom and how', 'Visual identity and positioning', 'Professional website with payment system', 'Corporate email + domain', 'Social media setup', 'Brand kit + Canva templates', 'Dashboard to view your web activity', 'Florida LLC (optional add-on)'],
    cta: 'Quiero construir mi negocio',
    ctaEn: 'I want to build my business',
    footer: '⏱ Tiempo de entrega: 7–10 días',
    footerEn: '⏱ Delivery time: 7–10 days',
    waText: 'Hola! Me interesa el camino Construye'
  }, {
    id: 'reactiva',
    accent: '#D4A574',
    accentRgb: '212, 165, 116',
    btnClass: 'bg-white text-inkova-dark hover:bg-inkova-border',
    tag: 'CAMINO 02',
    name: 'Reactiva',
    nameEn: 'Reactivate',
    tagline: 'Tu negocio existe. Hagámoslo funcionar de verdad.',
    taglineEn: "Your business exists. Let's make it really work.",
    badge: 'Para quien ya tiene algo pero está estancado',
    badgeEn: 'For those who have something but are stuck',
    checklist: ['Auditoría digital completa', 'Rediseño o mejora de presencia', 'Mensaje y oferta clarificados', 'Sistema de captación y cobro activado', 'Estrategia de contenido inicial', 'Dashboard actualizado'],
    checklistEn: ['Complete digital audit', 'Redesign or presence improvement', 'Clarified message and offer', 'Capture and payment system activated', 'Initial content strategy', 'Updated dashboard'],
    cta: 'Quiero reactivar lo que tengo',
    ctaEn: 'I want to reactivate what I have',
    footer: '⏱ Tiempo de entrega: 5–14 días',
    footerEn: '⏱ Delivery time: 5–14 days',
    waText: 'Hola! Me interesa el camino Reactiva'
  }, {
    id: 'trasciende',
    accent: '#9CAF88',
    accentRgb: '156, 175, 136',
    btnClass: 'bg-white text-inkova-dark hover:bg-inkova-border',
    tag: 'CAMINO 03',
    name: 'Trasciende',
    nameEn: 'Transcend',
    tagline: 'Tienes el negocio. Ahora vamos por más.',
    taglineEn: "You have the business. Now let's go for more.",
    badge: 'Para quien quiere crecer con propósito',
    badgeEn: 'For those who want to grow with purpose',
    checklist: ['Estrategia de crecimiento digital', 'Meta Ads + gestión de campañas', '2 sesiones de mentoría al mes', 'Plan de contenido mensual', 'Optimización de funnel y conversión', 'Acceso directo por WhatsApp'],
    checklistEn: ['Digital growth strategy', 'Meta Ads + campaign management', '2 mentoring sessions per month', 'Monthly content plan', 'Funnel and conversion optimization', 'Direct WhatsApp access'],
    cta: 'Quiero crecer con estrategia',
    ctaEn: 'I want to grow with strategy',
    footer: '⏱ Compromiso mínimo: 3 meses',
    footerEn: '⏱ Minimum commitment: 3 months',
    waText: 'Hola! Me interesa el camino Trasciende'
  }];
  return <section id="servicios" className="py-32 lg:py-40 bg-inkova-cream" data-id="element-370">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-371">
        <div className="text-center mb-24" data-id="element-372">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex flex-col items-center gap-4 mb-8" data-id="element-373">
            <span className="block w-[1px] h-[40px] bg-inkova-primary/30" data-id="element-374" />
            <span className="inline-block font-sans text-[11px] font-semibold tracking-[3px] uppercase text-inkova-primary" data-id="element-375">
              {lang === 'es' ? 'NUESTROS SERVICIOS' : 'OUR SERVICES'}
            </span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.1
        }} className="text-[32px] sm:text-[4vw] lg:text-[56px] font-serif text-inkova-dark leading-[1.1] tracking-[-0.5px] mb-6" data-id="element-376">
            {lang === 'es' ? <>
                ¿En qué <em className="italic text-inkova-lavender" data-id="element-377">etapa</em>{' '}
                estás?
              </> : <>
                What <em className="italic text-inkova-lavender" data-id="element-378">stage</em> are
                you in?
              </>}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="text-[16px] lg:text-[18px] text-inkova-dark/70 max-w-[600px] mx-auto font-light leading-[1.8]" data-id="element-379">
            {lang === 'es' ? 'No existe un plan genérico aquí. Empezamos por entender dónde estás — y construimos desde ahí.' : 'There is no generic plan here. We start by understanding where you are — and build from there.'}
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10 mb-16" data-id="element-380">
          {caminos.map((camino, index) => <motion.div key={camino.id} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: index * 0.15
        }} className="group bg-white rounded-[24px] overflow-hidden border border-inkova-border hover:border-inkova-primary/20 hover:-translate-y-2 hover:shadow-[0_24px_64px_rgba(107,63,160,0.10)] transition-all duration-500 flex flex-col" data-id="element-381">
              <div className="relative p-12 text-white overflow-hidden" style={{
            background: 'linear-gradient(160deg, #1a0f2e 0%, #0d0815 100%)'
          }} data-id="element-382">
                {/* Thin accent line at very top */}
                <div className="absolute top-0 left-0 right-0 h-[2px]" style={{
              backgroundColor: camino.accent
            }} data-id="element-383" />
                {/* Faint inner glow from above in accent hue */}
                <div className="pointer-events-none absolute -top-1/2 left-1/2 -translate-x-1/2 w-[140%] h-[100%]" style={{
              background: `radial-gradient(ellipse at top, rgba(${camino.accentRgb}, 0.18) 0%, transparent 60%)`
            }} data-id="element-384" />
                <div className="relative z-10" data-id="element-385">
                  <div className="text-[11px] font-sans font-semibold tracking-[3px] mb-4" style={{
                color: camino.accent
              }} data-id="element-386">
                    {camino.tag}
                  </div>
                  <div className="text-[32px] font-serif font-medium mb-3" data-id="element-387">
                    {lang === 'es' ? camino.name : camino.nameEn}
                  </div>
                  <div className="text-[15px] font-light text-white/75 mb-6 leading-[1.6]" data-id="element-388">
                    {lang === 'es' ? camino.tagline : camino.taglineEn}
                  </div>
                  <div className="inline-block px-4 py-2 rounded-full text-[12px] font-medium tracking-[0.5px] border" style={{
                borderColor: `rgba(${camino.accentRgb}, 0.35)`,
                backgroundColor: `rgba(${camino.accentRgb}, 0.08)`
              }} data-id="element-389">
                    {lang === 'es' ? camino.badge : camino.badgeEn}
                  </div>
                </div>
              </div>

              <div className="p-12 flex-1 flex flex-col bg-white" data-id="element-390">
                <ul className="flex-1 mb-10 space-y-4" data-id="element-391">
                  {(lang === 'es' ? camino.checklist : camino.checklistEn).map((item, i) => <li key={i} className="flex items-start gap-3 text-[15px] text-inkova-dark/80 font-light leading-[1.6]" data-id="element-392">
                        <Check className="w-5 h-5 text-inkova-lavender shrink-0 mt-0.5" strokeWidth={1.5} data-id="element-393" />
                        <span data-id="element-394">{item}</span>
                      </li>)}
                </ul>

                <a href={`https://wa.me/13054781618?text=${encodeURIComponent(camino.waText)}`} target="_blank" rel="noopener noreferrer" className={`block text-center py-4 px-6 rounded-[18px] font-sans font-medium text-[14px] tracking-[0.5px] uppercase transition-all duration-400 mb-6 ${camino.btnClass}`} data-id="element-395">
                  {lang === 'es' ? camino.cta : camino.ctaEn}
                </a>

                <div className="text-[13px] text-inkova-dark/50 text-center font-light" data-id="element-396">
                  {lang === 'es' ? camino.footer : camino.footerEn}
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.4
      }} className="text-center text-inkova-dark/60 text-[16px] font-light" data-id="element-397">
          {lang === 'es' ? <>
              ¿No sabes cuál es tu camino?{' '}
              <a href="https://calendly.com/inkovacreation" target="_blank" rel="noopener noreferrer" className="text-inkova-primary font-medium underline underline-offset-4 hover:text-inkova-lavender transition-colors" data-id="element-398">
                La Sesión Diagnóstico existe exactamente para eso.
              </a>
            </> : <>
              Don't know which path is yours?{' '}
              <a href="https://calendly.com/inkovacreation" target="_blank" rel="noopener noreferrer" className="text-inkova-primary font-medium underline underline-offset-4 hover:text-inkova-lavender transition-colors" data-id="element-399">
                The Diagnostic Session exists exactly for that.
              </a>
            </>}
        </motion.div>
      </div>
    </section>;
}